import { FormattedMessage } from 'react-intl';

import { Season26TutorialDialog } from '@sorare/core/src/components/dialog/Season26TutorialDialog';
import { Season26TutorialStep } from '@sorare/core/src/components/dialog/Season26TutorialStep';
import { glossary } from '@sorare/core/src/lib/glossary';

import { QuickPlayTutorialFooter } from '#src/components/quickPlay/QuickPlayTutorialDialog/QuickPlayTutorialFooter/index.tsx';
import type { QuickPlayTutorialDialogType } from '#src/components/quickPlay/QuickPlayTutorialDialog/types.ts';
import { QuickPlayTutorialHeader } from '#src/components/quickPlay/QuickPlayTutorialHeader/index.tsx';

import { Average } from './Average/index.tsx';
import { Success } from './Success/index.tsx';
import { Targets } from './Targets/index.tsx';
import background from './assets/background.webp';

type Props = {
  open: boolean;
  onContinue: () => void;
  loading: boolean;
  minimumTarget?: number;
  onSelect: (type: QuickPlayTutorialDialogType) => void;
};
export const TargetDialog = ({
  open,
  onContinue,
  loading,
  minimumTarget,
  onSelect,
}: Props) => {
  return (
    <Season26TutorialDialog
      open={open}
      onClose={onContinue}
      color="#F58426"
      textColor="var(--c-black)"
      headerBackgroundUrl={background}
      disableAnimation
      hideTextureBackground
      gap={2}
      titleGroup={
        <QuickPlayTutorialHeader
          overline={<FormattedMessage {...glossary.howToPlay} />}
          title={
            <FormattedMessage
              id="TargetDialog.title"
              defaultMessage="Targets"
            />
          }
        />
      }
      items={[
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.steps.l10"
              defaultMessage="L10 Average"
            />
          }
          key="l10-average"
          fullHeight={false}
        >
          <Average />
        </Season26TutorialStep>,
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="TargetDialog.title"
              defaultMessage="Targets"
            />
          }
          key="targets"
          fullHeight={false}
        >
          <Targets key="targets" minimumTarget={minimumTarget} />
        </Season26TutorialStep>,
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.steps.success"
              defaultMessage="Success"
            />
          }
          key="success"
          fullHeight={false}
        >
          <Success />
        </Season26TutorialStep>,
      ]}
      footer={
        <QuickPlayTutorialFooter
          onSelect={onSelect}
          onContinue={onContinue}
          loading={loading}
          selectedType="targets"
        />
      }
    />
  );
};
